<form [formGroup]="updatePasswordForm" class="flex flex-col gap-1 pt-2">
    <p class="font-bold">Password</p>
    <div class="flex flex-col gap-2">
        <div class="flex flex-row items-center gap-2">
            <div class="w-[16ch] text-right">
                Old Password
            </div>
            <input formControlName="old" type="password" class="p-1 bg-slate-100 rounded-sm shadow-sm grow disabled:text-slate-400">
        </div>
        <div class="flex flex-row items-center gap-2">
            <div class="w-[16ch] text-right">
                New Password
            </div>
            <input formControlName="new" type="password" class="p-1 bg-slate-100 rounded-sm shadow-sm grow disabled:text-slate-400">
        </div>
        <div class="flex flex-row items-center gap-2">
            <div class="w-[16ch] text-right">
                Confirm Password
            </div>
            <input formControlName="confirm" type="password" class="p-1 bg-slate-100 rounded-sm shadow-sm grow disabled:text-slate-400">
        </div>
        <div class="flex flex-row justify-end gap-2">
            <div class="flex flex-col p-1 gap-2 grow">
                @if (updateErrors) {
                    <div class="flex flex-col gap-1 border border-red-600 text-xs text-red-600 p-2 rounded">
                        {{ updateErrors }}
                    </div>
                }
                @if (!isPasswordChangeValid && invalidPasswordReasons.length) {
                    <div class="flex flex-col gap-1 border border-red-600 text-xs text-red-600 p-2 rounded">
                        @for(reason of invalidPasswordReasons ; track reason) {
                            <div>{{ reason }}</div>
                        }
                    </div>
                }
                <p class="text-xs text-slate-400">
                    You will be logged out upon successful password change.
                </p>
            </div>
            <div class="p-1">
                <button (click)="onChangePasswordClicked()" class="w-[8ch] p-1 bg-slate-100 rounded-sm shadow-sm hover:text-ponder-link hover:stroke-ponder-link hover:cursor-pointer border border-transparent hover:border-ponder-link disabled:text-slate-500 disabled:hover:text-slate-500 disabled:hover:cursor-default disabled:hover:border-transparent" [disabled]="!canSubmitPasswordChange()">
                    @if (!isUpdating) {
                        Save
                    } @else {
                        <busy-spin [small]="true"></busy-spin>
                    }
                </button>
            </div>
        </div>
    </div>
</form>